//************************************************************************ /
// SHARE STORY FOOTER
// Footer that displays on the event detail view if no stories are associated
// with the event.
//************************************************************************ /

import React from "react";
import { Button, Group } from "@dreambigger/design-system/src/components";
import { Event as EventType } from "@dreambigger/shared/src/types";
import { useGA } from "@dreambigger/shared/src/hooks";
import { optimizeCloudinaryImg } from "@dreambigger/shared/src/utils";

type ShareStoryFooterProps = {
  event: EventType;
};

const SAMPLE_STORY_IMAGE =
  "https://res.cloudinary.com/cotribute/image/upload/f_auto,q_auto/v1508798087/sample-event-stories_kwn2oe.jpg";

const ShareStoryFooter = ({ event }: ShareStoryFooterProps) => {
  // Load Analytics
  const googleAnalytics = useGA();

  const handleClick = () => {
    // Track analytics of button click
    googleAnalytics.event({
      category: "Event Detail Page",
      action: "Button Click",
      label: "Share a Photo or Comment",
      value: 1,
    });

    // Navigate user to share page.
    window.location.pathname = window.location.pathname.replace(
      "detail",
      "share"
    );
  };

  return (
    <Group
      xs="vertical"
      lg="horizontal"
      className="justify-center items-center max-w-100vw overflow-hidden"
      style={{
        backgroundColor: "#eceaed",
      }}
    >
      <div className="pt-5 lg_pt-0 w-100 lg_w-50">
        <div className="flex flex-column w-100 items-center">
          {/* Call To Action Text */}
          <h4 className="tc f-5 lh-3 mb-5">
            Help {event.host && event.host} collect photos from this event!
          </h4>
          {/* Button Link */}

          <Button
            type="primary"
            className={`bttu fwb f-3`}
            onClick={handleClick}
          >
            Share a Photo Or Comment
          </Button>
        </div>
      </div>
      <div className="flex flex-column items-center w-100 lg_w-50">
        <img
          src={optimizeCloudinaryImg(SAMPLE_STORY_IMAGE)}
          alt="Sample Event Stories"
          className="w-auto max-w-100vw"
          loading="lazy"
        ></img>
      </div>
    </Group>
  );
};

export default ShareStoryFooter;
